import { useContext } from 'react'
import { GenericStoreContext } from '@/contexts/genericStoreContext'
import { GenericStoreContextType } from '@/shared/types/generic'

/**
 * Hook to access the GenericStoreContext
 * Provides access to the store, setGenericStoreValue, getGenericStoreValue, and clearGenericStore
 */
const useGenericStore = (): GenericStoreContextType => {
  const context = useContext(GenericStoreContext)

  if (!context) {
    throw new Error('useGenericStore must be used within a GenericStoreProvider')
  }

  return context
}

export default useGenericStore